module.exports = __webpack_public_path__ + "img/icon_result.17b16ccd.svg";